const SIDEBAR_COLLAPSED_PREFERENCE_KEY = 'appSidebarCollapsed'

export function readSidebarCollapsedPreference() {
  try {
    return sessionStorage.getItem(SIDEBAR_COLLAPSED_PREFERENCE_KEY) === 'true'
  } catch {
    return false
  }
}

export function writeSidebarCollapsedPreference(collapsed) {
  try {
    sessionStorage.setItem(SIDEBAR_COLLAPSED_PREFERENCE_KEY, collapsed ? 'true' : 'false')
  } catch {}
}
